var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.50938C1 6.50938 4.20545 1 9.815 1C15.4245 1 18.63 6.50938 18.63 6.50938C18.63 6.50938 15.4245 12.0188 9.815 12.0188C4.20545 12.0188 1 6.50938 1 6.50938Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.815 8.87054C11.2755 8.87054 12.4595 7.81341 12.4595 6.50938C12.4595 5.20534 11.2755 4.14821 9.815 4.14821C8.35448 4.14821 7.1705 5.20534 7.1705 6.50938C7.1705 7.81341 8.35448 8.87054 9.815 8.87054Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOn);
export default __webpack_public_path__ + "static/media/visibility_on.6453a3ccfeb666d4fed6941a4e23b60c.svg";
export { ForwardRef as ReactComponent };